import { AuthDomain } from 'auth-lib-front';
import { DomainV2 } from 'troppus-common/domain';

import Project = AuthDomain.Object.Project;
import SourceSystem = DomainV2.Import.SourceSystem;

export const sourceSystemQueryKeys = {
  list: (projectId: Project.Id) => ['troppus', 'sourceSystem', 'list', projectId] as const,
  detail: (projectId: Project.Id, id: SourceSystem.Id) => ['troppus', 'sourceSystem', 'detail', projectId, id] as const,
};
